/**
 * `cv_reset_password_success` handling — read from TWO places in
 * AuthContext.js (initAuth's no-session check and the SIGNED_OUT handler),
 * extracted so that 500-line-capped file doesn't duplicate the same clear
 * logic twice (2026-09-25 password flow).
 *
 * ResetPassword.js sets this flag right before its own `signOut()`:
 *   - 'silent' — the reset page already showed its OWN done screen (a
 *     MfaSuccessMark + "Password updated") before signing out. AuthContext
 *     must still clear the flags, but must NOT ALSO surface its
 *     `auth.notices.passwordReset` banner on top of that — this function
 *     returns `false` so the caller skips `setAuthNotice`.
 *   - any other value (historically '1') — keeps today's behavior: the
 *     flags clear AND the caller still shows the notice.
 *
 * @returns {boolean} whether the caller should still set the passwordReset auth notice
 */
export function consumeResetPasswordSuccessFlag() {
  const resetFlag = sessionStorage.getItem('cv_reset_password_success');
  sessionStorage.removeItem('cv_reset_password_success');
  sessionStorage.removeItem('cv_session_expired');
  return resetFlag !== 'silent';
}
